import { render, staticRenderFns } from "./PartnerNotFound.vue?vue&type=template&id=38477548"
import script from "./PartnerNotFound.vue?vue&type=script&lang=js"
export * from "./PartnerNotFound.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports